'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');
const Guid=require('pulsar-utils/dist-es6/domain/guid');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

AddressValidatorController=function(){_createClass(AddressValidatorController,null,[{key:'$inject',get:function()
{return['$scope','socketService','$timeout']}}]);

function AddressValidatorController($scope,socketService,$timeout){var _this=this;_classCallCheck(this,AddressValidatorController);
this._socketService=socketService;
this._$timeout=$timeout;

this._inputId=Guid.create().toString();

this.isValid=!0;
this.errorMessage='';

this._debouncedValidate=_.debounce(this._validate,500);

$scope.$watch('controller.address',function(newAddress){
_this._debouncedValidate(newAddress);
});
}AddressValidatorController.prototype.





_updateValidity=function _updateValidity(isValid,errorMessage){var _this2=this;
this._$timeout(function(){
_this2.isValid=isValid;
_this2.errorMessage=errorMessage;
});
};AddressValidatorController.prototype.

_validate=function(){var ref=_asyncToGenerator(function*(address){
if(!_.exists(address)||address.length===0){
this._updateValidity(!1,'Please enter an address.');
return;
}else if(address.split(/\s+/g).length<2){
this._updateValidity(!1,'Please enter a valid address.');
return;
}

let validationResponse=yield this._socketService.sendAndWaitForResponse('ValidateAddress',address);

this._updateValidity(validationResponse.valid,validationResponse.message);
});function _validate(address){return ref.apply(this,arguments)}return _validate}();_createClass(AddressValidatorController,[{key:'inputId',get:function(){return this._inputId}}]);return AddressValidatorController}();let


AddressValidatorDirective=function(_BaseControllerBacked){_inherits(AddressValidatorDirective,_BaseControllerBacked);function AddressValidatorDirective(){_classCallCheck(this,AddressValidatorDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(AddressValidatorDirective,[{key:'templateUrl',get:function()
{return'/templates/directives/addressValidatorDirective/addressValidatorTemplate'}},{key:'objectBindings',get:function()
{return['address','form']}},{key:'controller',get:function()
{return AddressValidatorController}}]);return AddressValidatorDirective}(BaseControllerBackedDirective);


module.exports=AddressValidatorDirective;
//# sourceMappingURL=addressValidatorDirective.js.map
